module.exports = __webpack_public_path__ + "static/images/styles/core/components/button/images/default-active-bg-left.c5a8c277.png";


//////////////////
// WEBPACK FOOTER
// ./styles/core/components/button/images/default-active-bg-left.png
// module id = 3481
// module chunks = 11